import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import ArticleIcon from '@mui/icons-material/Article';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CategoryIcon from '@mui/icons-material/Category';
import ChecklistIcon from '@mui/icons-material/Checklist';
import CodeIcon from '@mui/icons-material/Code';
import EditIcon from '@mui/icons-material/Edit';
import FolderIcon from '@mui/icons-material/Folder';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import HighlightIcon from '@mui/icons-material/Highlight';
import HistoryIcon from '@mui/icons-material/History';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import LinkIcon from '@mui/icons-material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import RedoIcon from '@mui/icons-material/Redo';
import PrintIcon from '@mui/icons-material/Print';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import TableChartIcon from '@mui/icons-material/TableChart';
import TitleIcon from '@mui/icons-material/Title';
import UndoIcon from '@mui/icons-material/Undo';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';

const normalizeVisualKey = (value = '') => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export const getWikiDocumentVisual = (type = '') => {
  const key = normalizeVisualKey(type);
  if (key.includes('procedure')) return { Icon: AssignmentOutlinedIcon, tone: 'teal' };
  if (key.includes('mode operatoire')) return { Icon: FactCheckOutlinedIcon, tone: 'blue' };
  if (key.includes('guide')) return { Icon: MenuBookOutlinedIcon, tone: 'blue' };
  if (key.includes('checklist')) return { Icon: RuleOutlinedIcon, tone: 'coral' };
  if (key.includes('modele')) return { Icon: ContentCopyOutlinedIcon, tone: 'orange' };
  if (key.includes('fiche technique')) return { Icon: EngineeringOutlinedIcon, tone: 'cyan' };
  if (key.includes('retour')) return { Icon: LightbulbOutlinedIcon, tone: 'purple' };
  if (key.includes('faq')) return { Icon: HelpCenterOutlinedIcon, tone: 'indigo' };
  if (key.includes('referentiel')) return { Icon: VerifiedOutlinedIcon, tone: 'green' };
  return { Icon: DescriptionOutlinedIcon, tone: 'pink' };
};

export const getWikiCategoryVisual = (category = '') => {
  const key = normalizeVisualKey(category);
  if (key.includes('commerce')) return { Icon: StorefrontOutlinedIcon, tone: 'orange' };
  if (key.includes('gestion') || key.includes('projet')) return { Icon: AccountTreeOutlinedIcon, tone: 'pink' };
  if (key.includes('technique')) return { Icon: EngineeringOutlinedIcon, tone: 'blue' };
  if (key.includes('qualite')) return { Icon: VerifiedOutlinedIcon, tone: 'teal' };
  if (key.includes('ressources') || key.includes('humaines')) return { Icon: GroupsOutlinedIcon, tone: 'green' };
  if (key.includes('entreprise')) return { Icon: BusinessOutlinedIcon, tone: 'cyan' };
  return { Icon: FolderIcon, tone: 'pink' };
};

export const WikiDocumentIcon = ({ type, ...props }) => {
  const { Icon } = getWikiDocumentVisual(type);
  return <Icon {...props} />;
};

export const WikiCategoryIcon = ({ category, ...props }) => {
  const { Icon } = getWikiCategoryVisual(category);
  return <Icon {...props} />;
};

export {
  AddIcon,
  ArticleIcon,
  ArrowBackIcon,
  CategoryIcon,
  ChecklistIcon,
  CodeIcon,
  EditIcon,
  FolderIcon,
  FormatAlignCenterIcon,
  FormatAlignJustifyIcon,
  FormatAlignLeftIcon,
  FormatAlignRightIcon,
  FormatBoldIcon,
  FormatClearIcon,
  FormatIndentDecreaseIcon,
  FormatIndentIncreaseIcon,
  FormatItalicIcon,
  FormatListBulletedIcon,
  FormatListNumberedIcon,
  FormatQuoteIcon,
  FormatUnderlinedIcon,
  HighlightIcon,
  HistoryIcon,
  HorizontalRuleIcon,
  ImageIcon,
  InsertDriveFileIcon,
  LinkIcon,
  MenuIcon,
  PrintIcon,
  RedoIcon,
  RefreshIcon,
  SearchIcon,
  StarIcon,
  StarBorderIcon,
  StrikethroughSIcon,
  TableChartIcon,
  TitleIcon,
  UndoIcon,
};
